import {
    INSCRIPCION_PASO_UNO_AL_DOS_URL,
    INSCRIPCION_PASO_UNO_AL_CERO_URL,
    INSCRIPCION_ASYNC_URL,
    PERSONA_URL
} from '../config';
import axios from 'axios';

export function postPasoUnoAlDos(params) {
    const result = axios.post(INSCRIPCION_PASO_UNO_AL_DOS_URL, params);
    return result;
};

export function postPasoUnoAlCero(params) {
    const result = axios.post(INSCRIPCION_PASO_UNO_AL_CERO_URL, params);
    return result;
}

export const getPasoFromId = async (params) => {
    const url = `${INSCRIPCION_ASYNC_URL}?inscripcionId=${params}`;
    const result = await axios.get(url);
    return result;
};

// export const getResponsableInformacion = async (params) => {
//     const url = `${RESPONSABLE_URL}?sexo=${params.sexo}&nroDocumento=${params.nroDocumento}`;
//     const result = await axios.get(url);
//     return result;
// };

export const getResponsableInformacion = async (params) => {
    const url = `${PERSONA_URL}?sexo=${params.sexo}&nroDocumento=${params.nroDocumento}`;
    const result = await axios.get(url);
    return result;
};
